import { render, staticRenderFns } from "./we-image.vue?vue&type=template&id=84936722&"
import script from "./we-image.vue?vue&type=script&lang=js&"
export * from "./we-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports